import { createApi } from '@reduxjs/toolkit/query/react';
import apiRoutesV2 from 'src/config/api/routes';
import { appBaseQuery } from 'src/modules/shared/slices/helpers';
import { TableOfContentsChapterDetailsResponse, TableOfContentsResponse } from './types';

export const tableOfContentsApi = createApi({
  reducerPath: 'tableOfContentsApi',
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    getTableOfContent: builder.query<TableOfContentsResponse, string>({
      query: (bookId) => ({
        url: apiRoutesV2.tableOfContents(bookId),
        method: 'GET',
      }),
    }),
    getTableOfContentChapters: builder.query<
      TableOfContentsChapterDetailsResponse,
      { chapterId: string }
    >({
      query: ({ chapterId }) => ({
        url: apiRoutesV2.tableOfContentsChapters(chapterId),
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetTableOfContentQuery, useGetTableOfContentChaptersQuery } = tableOfContentsApi;
